var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b27558b19f93d1c90f99732d0f0adfdd0b006285"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["clhbidcom@clhbid"]={id:"b27558b19f93d1c90f99732d0f0adfdd0b006285"};
      